import type { JSONConfig } from '@/engine/app/interfaces.ts';

export const heart: JSONConfig.ImageStack = {
  descriptor: 'Heart',
  label: 'Heart'
};

export const body: JSONConfig.ImageStack = {
  descriptor: 'Body',
  label: 'Body'
};
